import { Button } from "@/ui-kit"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/ui-kit/components/Dialog"

type EndConversationDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirmEnd: () => void
}

export function EndConversationDialog({
  open,
  onOpenChange,
  onConfirmEnd,
}: EndConversationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle className="!text-xl">End conversation?</DialogTitle>
          <DialogDescription>
            This will end the conversation for all participants.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="bordered" onClick={() => onOpenChange(false)}>
            Continue talking
          </Button>
          <Button className="bg-red! text-white" onClick={onConfirmEnd}>
            End conversation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
